import {getJson, postJson} from '@/util/ajaxUtils';
import {API_ROOT} from '@/env';

export function sensitiveHitList() {
    return getJson('/sensitiveHit/list', {});
}

export function getSensitiveHitById(id) {
    return getJson(`/sensitiveHit/${id}`, {});
}

export function sensitiveHitUserInfo(data) {
    return postJson('/sensitiveHit/info', {data: data});
}

export function sensitiveHitDownloadUrl(start, end, corpId) {
    return `${API_ROOT}/sensitiveHit/download?start=${start}&end=${end}&corpId=${corpId}`;
}
